import { define } from 'wicked-elements'
import breakjs from 'breakjs'
import arrayShuffle from 'array-shuffle'
import percentageInView from '../lib/percentage-in-view.js'
function fuzzyEqual (x, y) {
  let min = y - 1
  let max = y + 1
  return ((x-min)*(x-max) <= 0)
}

define('[data-component~="home-grid"]', {
  init () {
    this.$grid = this.element.querySelector('[data-grid]')
    this.featured = [...this.element.querySelector('[data-featured]').content.children]
    this.entries = [...this.element.querySelector('[data-entries]').content.children]
    this.shuffleFeatured = this.element.dataset.shuffleFeatured === 'true'
    this.shuffleEntries = this.element.dataset.shuffleEntries === 'true'
    
    if (this.shuffleFeatured) {
      this.featured = arrayShuffle(this.featured)
    }

    if (this.shuffleEntries) {
      this.entries = arrayShuffle(this.entries)
    }

    this.breakjs = breakjs({
      min: 0,
      md: 768,
      lg: 1024,
      xl: 1200,
      '4xl': 1800
    })

    this.layouts = {
      min: {
        withFeaturedOdd: [2, 1, 1],
        withFeaturedEven: [2, 1, 1],
        odd: [1],
        even: [1],
        offsetWhen: []
      },
      md: {
        withFeaturedOdd: [2, 1, 0],
        withFeaturedEven: [1, 2, 0],
        odd: [1, 0, 1],
        even: [0, 1, 0],
        offsetWhen: [true]
      },
      lg: {
        withFeaturedOdd: [2, 1, 0, 0, 1],
        withFeaturedEven: [0, 1, 2, 1, 0],
        odd: [1, 0, 1, 0],
        even: [0, 1, 0, 1],
        offsetWhen: [false, true]
      },
      xl: {
        withFeaturedOdd: [2, 1, 0, 1, 0, 1, 0],
        withFeaturedEven: [1, 0, 1, 2, 0, 1, 0],
        odd: [1, 0, 1, 0, 1],
        even: [0, 1, 0, 1, 0],
        offsetWhen: [true]
      },
      '4xl': {
        withFeaturedOdd: [2, 1, 0, 1, 0, 0, 1, 0, 1],
        withFeaturedEven: [1, 0, 1, 0, 2, 0, 1, 0, 1],
        odd: [1, 0, 1, 0, 1, 0],
        even: [0, 1, 0, 1, 0, 1],
        offsetWhen: [true]
      }
    }

    this.layout = this.layouts['4xl']
    this.items = []
    this.row = 0
    this.indexEntries = 0
    this.indexFeatured = 0
    this.lastFeatured = false

    this.render = this.render.bind(this)
    this.renderArrow = this.renderArrow.bind(this)
    this.destroyArrow = this.destroyArrow.bind(this)
  },
  connected () {
    this.render()
    this.breakjs.addChangeListener(this.render)
    this.bindArrowEvents()
  },
  disconnected () {
    this.breakjs.removeChangeListener(this.render)
    this.unbindArrowEvents()
  },
  generateLayout () {
    this.items = []
    this.row = 0
    this.indexEntries = 0
    this.indexFeatured = 0
    this.lastFeatured = false

    // get current layout based on breakpoint
    const breakpoint = this.breakjs.current()
    this.layout = this.layouts[breakpoint]

    // loop through entries and populate row templates
    while ((this.indexEntries < this.entries.length) || (this.indexFeatured < this.featured.length)) {
      const isOdd = !!(!(this.row % 2))

      // odd
      if (isOdd) {
        if (this.indexFeatured < this.featured.length) {
          this.populateLayout(this.layout.withFeaturedOdd)
        } else {
          this.populateLayout(this.layout.odd)
        }
      // even
      } else {
        if (this.indexFeatured < this.featured.length) {
          this.populateLayout(this.layout.withFeaturedEven)
        } else {
          this.populateLayout(this.layout.even)
        }
      }

      // offset the layout depending on where last featured row lands
      if ((this.indexFeatured >= this.featured.length) && !this.lastFeatured) {
        this.lastFeatured = true
        if (this.layout.offsetWhen.includes(isOdd)) {
          this.row++  
        }
      }

      // increment row
      this.row++
    }

    return this.items
  },
  populateLayout (layout) {
    layout.forEach(item => {
      if (item === 2 && this.featured[this.indexFeatured]) {
        this.items.push(this.featured[this.indexFeatured])
        this.indexFeatured++  
      } else if (item === 1 && this.entries[this.indexEntries]) {
        this.items.push(this.entries[this.indexEntries])
        this.indexEntries++  
      } else if ((this.indexEntries < this.entries.length) || (this.indexFeatured < this.featured.length)) {
        this.items.push(document.createElement('div'))
      }
    })
  },
  bindArrowEvents () {
    this.featured.forEach($el => $el.addEventListener('mouseenter', this.renderArrow))
    this.featured.forEach($el => $el.addEventListener('mouseleave', this.destroyArrow))
    this.entries.forEach($el => $el.addEventListener('mouseenter', this.renderArrow))
    this.entries.forEach($el => $el.addEventListener('mouseleave', this.destroyArrow))
  },
  unbindArrowEvents () {
    this.featured.forEach($el => $el.addEventListener('mouseenter', this.renderArrow))
    this.featured.forEach($el => $el.addEventListener('mouseleave', this.destroyArrow))
    this.entries.forEach($el => $el.addEventListener('mouseenter', this.renderArrow))
    this.entries.forEach($el => $el.addEventListener('mouseleave', this.destroyArrow))
  },
  renderArrow (e) {
    if (window.innerWidth < 768) return

    // s = source dimensions
    // t = target dimensions

    const empties = [...this.$grid.querySelectorAll('div:empty')]
    const source = e.target
    const s = source.getBoundingClientRect()

    // Find all adjacent empty blocks
    let matches = empties.filter($el => {
      let t = $el.getBoundingClientRect()

      // require at least 15% of element in viewport
      if (percentageInView($el) < 15) return false

      if (fuzzyEqual(s.bottom, t.top) && (fuzzyEqual(s.left, t.left) || fuzzyEqual(s.right, t.right))) {
        $el.classList.add('direction-up')
        return true
      }
      if (fuzzyEqual(s.top, t.bottom) && (fuzzyEqual(s.left, t.left) || fuzzyEqual(s.right, t.right))) {
        $el.classList.add('direction-down')
        return true
      }
      if (fuzzyEqual(s.left, t.right) && (fuzzyEqual(s.top, t.top) || fuzzyEqual(s.bottom, t.bottom))) {
        $el.classList.add('direction-right')
        return true
      }
      if (fuzzyEqual(s.right, t.left) && (fuzzyEqual(s.top, t.top) || fuzzyEqual(s.bottom, t.bottom))) {
        $el.classList.add('direction-left')
        return true
      }
    })

    // Pick random adjacent block
    let shuffled = arrayShuffle(matches)
    if (shuffled.length) {
      shuffled[0].classList.add('show-direction')
    }
  },
  destroyArrow (e) {
    if (window.innerWidth < 768) return
    const empties = [...this.$grid.querySelectorAll('div:empty')]
    empties.forEach($el => $el.removeAttribute('class'))
  },
  render () {
    const entries = this.generateLayout()
    this.$grid.innerHTML = ''
    entries.forEach(entry => {
      this.$grid.appendChild(entry)
    })
  }
})